export default "__VITE_ASSET__DbSn5dJS__"